import { render } from "./ConfirmModal.vue?vue&type=template&id=0184a0b4&scoped=true&ts=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts"

import "./ConfirmModal.vue?vue&type=style&index=0&id=0184a0b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0184a0b4"]])

export default __exports__